import React from 'react';
import { useVerificationWizard } from '../useVerificationWizard';
import ServicesForm from '../../wizard/forms/ServicesForm';
import VerificationStepActionBar from '../VerificationStepActionBar';
import { VERIFICATION_STEPS } from '../../../types/verification';
import '../../../pages/VerificationWizardPage.css';

const STEP = VERIFICATION_STEPS.SERVICES_PRICING;

const VerifyProceduresStep: React.FC = () => {
  const {
    state,
    updateServices,
    saveServices,
    markStepConfirmed,
    markStepSkipped,
    getStepStatus,
    isSaving,
  } = useVerificationWizard();

  return (
    <div className="wizard-step">
      <h2>Verify Procedures</h2>
      <p className="step-description">Review the clinic's available procedures.</p>

      <div className="verify-section">
        <h3 className="verify-section-heading">
          Procedures
        </h3>
        <ServicesForm
          services={state.services}
          onUpdateServices={updateServices}
        />
      </div>

      <VerificationStepActionBar
        stepStatus={getStepStatus(STEP)}
        isSaving={isSaving}
        onSaveChanges={saveServices}
        onNoChanges={() => markStepConfirmed(STEP)}
        onSkip={(notes) => markStepSkipped(STEP, notes)}
      />
    </div>
  );
};

export default VerifyProceduresStep;
